import {Checkbox, FormControlLabel, Stack, TextField, Typography} from '@mui/material';
import React from 'react';
import {useFormContext} from 'react-hook-form';

import {translations} from 'presentation/translations-new';
import {AddressDataFormValues} from '../../../AddressForm/validation';
import {AddressFieldsProps} from './types';
import {FieldsContainer, StyledTextField} from './styles';

const {address: addressLabel} = translations['pt-br'].privateFlow.profile.changeData;

export function AddressFields({
	showOtherFields,
	unmaskedZipCode,
	fieldDisabledState,
	watchWithoutNumber,
	onWithoutNumberChange,
}: AddressFieldsProps) {
	const {
		register,
		formState: {errors},
	} = useFormContext<AddressDataFormValues>();

	if (!showOtherFields) {
		return null;
	}

	return (
		<Stack gap={2}>
			<TextField
				{...register('address')}
				id="typeAddress"
				error={!!errors.address}
				helperText={
					errors.address?.message ? errors.address.message : addressLabel.addressInfo
				}
				slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
				fullWidth
				label={addressLabel.address}
				placeholder={addressLabel.address}
				disabled={unmaskedZipCode.length === 8 && fieldDisabledState.address}
			/>

			<Stack direction="row" gap={2} alignItems="center">
				<StyledTextField
					{...register('number')}
					id="number"
					sx={{flex: 1}}
					disabled={watchWithoutNumber}
					error={!!errors.number && !watchWithoutNumber}
					label={addressLabel.number}
					placeholder={addressLabel.number}
					fullWidth
					helperText={
						errors.number?.message && !watchWithoutNumber ? errors.number.message : ''
					}
					slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
					inputMode="numeric"
					type="number"
				/>
				<FormControlLabel
					sx={{
						width: 'fit-content',
						height:
							errors.number?.message && !watchWithoutNumber ? 'fit-content' : 'auto',
					}}
					control={
						<Checkbox
							{...register('withoutNumber')}
							onChange={onWithoutNumberChange}
							checked={watchWithoutNumber}
						/>
					}
					label={<Typography noWrap>{addressLabel.withoutNumber}</Typography>}
					labelPlacement="end"
				/>
			</Stack>

			<TextField
				{...register('complement')}
				id="complement"
				error={!!errors.complement}
				helperText={
					errors.complement?.message
						? errors.complement.message
						: addressLabel.complementInfo
				}
				slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
				fullWidth
				label={`${addressLabel.complement} ${addressLabel.optional}`}
				placeholder={addressLabel.complement}
			/>
			<TextField
				{...register('district')}
				id="district"
				error={!!errors.district}
				helperText={errors.district?.message ? errors.district.message : undefined}
				slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
				fullWidth
				label={addressLabel.district}
				placeholder={addressLabel.district}
				disabled={unmaskedZipCode.length === 8 && fieldDisabledState.district}
			/>

			<FieldsContainer>
				<TextField
					{...register('city')}
					id="city"
					error={!!errors.city}
					helperText={errors.city?.message ? errors.city.message : undefined}
					slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
					fullWidth
					label={addressLabel.city}
					placeholder={addressLabel.city}
					disabled={unmaskedZipCode.length === 8 && fieldDisabledState.city}
				/>
				<TextField
					{...register('state')}
					id="state"
					error={!!errors.state}
					helperText={errors.state?.message ? errors.state.message : undefined}
					slotProps={{
						formHelperText: {sx: {fontSize: '0.75rem'}},
						htmlInput: {maxLength: 2},
					}}
					fullWidth
					label={addressLabel.state}
					placeholder={addressLabel.state}
					disabled={unmaskedZipCode.length === 8 && fieldDisabledState.state}
				/>
			</FieldsContainer>
		</Stack>
	);
}
